import { createAction, props } from '@ngrx/store';

export const getUnits = createAction(
  '[Units] Get Units',
);

export const updateUnitName = createAction(
  '[Units] Update Unit Name',
  props<{unitId: number, name: string}>()
);

export type UnitsActionsUnion = ReturnType<
  typeof getUnits |
  typeof updateUnitName
  >;
